(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nj-klaviyo-reviews-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", (e) => {
      const review = e.target.closest(".klaviyo-star-rating-widget");

      if (!review) return;

      const modal = document.getElementById("nj-klaviyo-reviews-modal");
      if (!modal) return;

      const modalInner = modal.querySelector(".modal-inner");

      const dataId = review.getAttribute("data-id");
      if (!dataId) return;

      modalInner?.querySelector("#fulfilled-reviews-all")?.remove();

      const newDiv = document.createElement("div");
      newDiv.id = "fulfilled-reviews-all";
      newDiv.setAttribute("data-id", dataId);

      modalInner?.appendChild(newDiv);

      if (window.klReviewsObject?.renderWidgets) {
          window.klReviewsObject.renderWidgets();
      }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["remote-area-shipping-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', async () => {
    const GEO_CACHE_KEY = 'remote_shipping_geo';
    const ACK_KEY = 'remote_shipping_acknowledged';
    const CACHE_DAYS = 3;

    let geoData = null;

    try {
      const cached = localStorage.getItem(GEO_CACHE_KEY);

      if (cached) {
        const parsed = JSON.parse(cached);

        const age = Date.now() - parsed.timestamp;
        const maxAge = CACHE_DAYS * 24 * 60 * 60 * 1000;

        if (age < maxAge) {
          geoData = parsed;
        }
      }

      if (!geoData) {
        const response = await fetch('https://geo.cleanflow.net');

        if (!response.ok) {
          return;
        }

        geoData = await response.json();
        geoData.timestamp = Date.now();

        localStorage.setItem(GEO_CACHE_KEY, JSON.stringify(geoData));
      }

      document.addEventListener('product:added', function () {
        if (localStorage.getItem(ACK_KEY) === 'true') {
          return;
        }

        const cachedGeo = JSON.parse(localStorage.getItem(GEO_CACHE_KEY) || '{}');

        if (!cachedGeo.showPopup) {
          return;
        }

        const checkbox = document.getElementById('remoteShippingAcknowledge');

        const button = document.getElementById('remoteShippingConfirm');

        if (!checkbox || !button) {
          return;
        }

        checkbox.checked = false;
        button.disabled = true;

        checkbox.onchange = () => {
          button.disabled = !checkbox.checked;
        };

        button.onclick = () => {
          localStorage.setItem(ACK_KEY, 'true');

          document.dispatchEvent(new CustomEvent('modal:close'));
        };

        const trigger = document.createElement('button');
        trigger.setAttribute('aria-controls', 'remote-shipping-modal');

        const manager = new ModalManager();
        manager._openModal(null, trigger);
      });
    } catch (error) {
      console.error('Remote Shipping Error', error);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
